import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const emptyStringValidator: ValidatorFn = (control: AbstractControl<string | null>): ValidationErrors | null => {
  if (!control.value?.toString().trim()) {
    return { required: true };
  }
  return null;
};
